import { memo } from 'react'
import { Button, Popover } from 'antd'
import './PopverButton.less'

const PopverButton = ({
  onClick,
  text,
  type = 'primary',
  disabled = true,
  content,
  isGradient = false,
  className = '',
  style = {}
}: any) => {
  return (
    <>
      {disabled ? (
        <Popover placement='top' content={content}>
          <Button type={type} disabled={true} className={`base-button disabled-button ${className}`}>
            {typeof text == 'function' ? text() : text}
          </Button>
        </Popover>
      ) : (
        <Button
          type={type}
          onClick={onClick}
          className={`base-button  ${className} ${isGradient ? 'gradient-button' : ''}`}
          style={{ ...style }}
        >
          {typeof text == 'function' ? text() : text}
        </Button>
      )}
    </>
  )
}

export default memo(PopverButton)
